// Una /32 representa una única dirección, no una red con capacidad ampliable.
export const isCapacityAlert = (subnet) =>
  Number(subnet.mask) !== 32 && (subnet.utilization || 0) >= 90;
